import { useDispatch } from "react-redux";
import { useAuth } from "react-oidc-context";
import {
  logOut,
} from "../user/userSlice";
import { logoutUser } from "../../auth/logoutHelper";

function LogoutPage() {

  const auth = useAuth();
  let dispatch = useDispatch();
  const logout = () => {
    logoutUser({ auth, dispatch });
  }

  logout();
}


export default LogoutPage;